if (!customElements.get('product-variant')) {
  class ProductVariant extends HTMLElement {
    /**
     * Properties.
     */
    selectors = {
      collection: 'variants-collection',
      group: 'variants-group',
      removeBtn: '[data-variants-compare-remove]',
      checkbox: '[data-variants-compare-checkbox]',
    };

    /**
     * constructor.
     */
    constructor() {
      super();
    }

    /**
     * connectedCallback.
     */
    connectedCallback() {
      this.collection = this.closest(this.selectors.collection);
      this.group = this.closest(this.selectors.group);
      this.checkbox = this.querySelector(this.selectors.checkbox);
      this.removeBtn = this.querySelector(this.selectors.removeBtn);

      this.attachListeners();
    }

    /**
     * attachListeners.
     */
    attachListeners() {
      this.checkbox?.addEventListener(
        'change',
        this.handleCheckboxChange.bind(this),
      );

      this.removeBtn?.addEventListener(
        'click',
        this.handleRemoveClick.bind(this),
      );
    }

    /**
     * handleCheckboxChange.
     * @param {Event} e
     */
    handleCheckboxChange(e) {
      const { checked } = e.currentTarget;

      const event = new CustomEvent('compare', {
        detail: {
          product: this,
          checked,
        },
      });

      this.collection.dispatchEvent(event);
    }

    /**
     * handleRemoveClick.
     */
    handleRemoveClick() {
      const { id: productId } = this.dataset;

      const event = new CustomEvent('remove', {
        detail: {
          productId,
        },
      });

      this.collection.dispatchEvent(event);
    }
  }

  customElements.define('product-variant', ProductVariant);
}
